<div class="element-page">
    <div class="row">
        <div class="col-sm-3">
            <div class="">
                <span style="font-weight: bold;">Filter Placement</span>
                <p (cclClick)="catalogLayoutConfig.filterPlacement = 'left'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'filterPlacement'"
                        [id]="'filterPlacementLeft'"
                        [value]="'left'"
                        [model]="catalogLayoutConfig.filterPlacement"
                        >Left</ccl-radio-button
                    >
                    <img
                        alt="Left Filter Placement"
                        [src]="
                            catalogLayoutConfig.filterPlacement == 'left'
                                ? 'assets/images/element-page/Elements_Filter_Left_ON.png'
                                : 'assets/images/element-page/Elements_Filter_Left_OFF.png'
                        "
                        class="img-height"
                    />
                </p>
                <p *ngIf="false" (cclClick)="catalogLayoutConfig.filterPlacement = 'top'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'filterPlacement'"
                        [id]="'filterPlacementTop'"
                        [value]="'top'"
                        [model]="catalogLayoutConfig.filterPlacement"
                        >Top</ccl-radio-button
                    >
                    <img
                        alt="Top Filter Placement"
                        [src]="
                            catalogLayoutConfig.filterPlacement == 'top'
                                ? 'assets/images/element-page/Elements_Filter_Top_ON.png'
                                : 'assets/images/element-page/Elements_Filter_Top_OFF.png'
                        "
                        class="img-height"
                    />
                </p>
                <p (cclClick)="catalogLayoutConfig.filterPlacement = 'slider'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'filterPlacement'"
                        [id]="'filterPlacementSlider'"
                        [value]="'slider'"
                        [model]="catalogLayoutConfig.filterPlacement"
                        >Slider</ccl-radio-button
                    >
                    <img
                        alt="Slider Filter Placement"
                        [src]="
                            catalogLayoutConfig.filterPlacement == 'slider'
                                ? 'assets/images/element-page/Elements_Filter_Slider_ON.png'
                                : 'assets/images/element-page/Elements_Filter_Slider_OFF.png'
                        "
                        class="img-height"
                    />
                </p>
            </div>
        </div>

        <div *ngIf="catalogLayoutConfig.highlightedStyle && catalogLayoutConfig.promotedStyle && catalogLayoutConfig.generalStyle" class="col-sm-6">
            <div class="ep-center-image">
                <img
                    alt="Magazine List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='list'"
                    src="assets/images/element-page/Left_Magazine.png"
                />
                <img
                alt="Magazine Card Layout with Left Filter"
                *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='card'"
                src="assets/images/element-page/Left_Magazine_Grid.png"
            />
                <img
                    alt="Promoted List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='list'"
                    src="assets/images/element-page/Left_Promotional.png"
                />

                <img
                alt="Promoted Card Layout with Left Filter"
                *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='card'"
                src="assets/images/element-page/Left_Promotional_Grid.png"
            />
                <img
                    alt="General List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='list'"
                    src="assets/images/element-page/Left_General.png"
                />
                <img
                    alt="General Card Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='card'"
                    src="assets/images/element-page/Left_General_Grid.png"
                />

                <img
                    alt="Magazine List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='list'"
                    src="assets/images/element-page/Top_Magazine.png"
                />
                <img
                alt="Magazine Card Layout with Top Filter"
                *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='card'"
                src="assets/images/element-page/Top_Magazine_Grid.png"
            />
                <img
                    alt="Promoted List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='list'"
                    src="assets/images/element-page/Top_Promotional.png"
                />

                <img
                    alt="Promoted Card Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='card'"
                    src="assets/images/element-page/Top_Promotional_Grid.png"
                />
                <img
                    alt="General List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='list'"
                    src="assets/images/element-page/Top_General.png"
                />

                <img
                alt="General Card Layout with Top Filter"
                *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='card'"
                src="assets/images/element-page/Top_General_Grid.png"
            />

                <img
                    alt="Magazine List Layout with Slider Filter"
                    *ngIf="
                        catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='list'
                    "
                    src="assets/images/element-page/Slider_Magazine.png"
                />

                <img
                    alt="Magazine Card Layout with Slider Filter"
                    *ngIf="
                        catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'magazine' && catalogLayoutConfig.highlightedStyle =='card'
                    "
                    src="assets/images/element-page/Slider_Magazine_Grid.png"
                />
                
                <img
                    alt="Promoted List Layout with Slider Filter"
                    *ngIf="
                        catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='list'
                    "
                    src="assets/images/element-page/Slider_Promotional.png"
                />

                <img
                    alt="Promoted Card Layout with Slider Filter"
                    *ngIf="
                        catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'promoted' && catalogLayoutConfig.promotedStyle =='card'
                    "
                    src="assets/images/element-page/Slider_Promotional_Grid.png"
                />

                <img
                    alt="General List Layout with Slider Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='list'"
                    src="assets/images/element-page/Slider_General.png"
                />

                <img
                    alt="General Card Layout with Slider Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'general' && catalogLayoutConfig.generalStyle =='card'"
                    src="assets/images/element-page/Slider_General_Grid.png"
                />
            </div>
        </div>


        <!-- backward compatiblity starts -->
        <div *ngIf="!catalogLayoutConfig.highlightedStyle && !catalogLayoutConfig.promotedStyle && !catalogLayoutConfig.generalStyle" class="col-sm-6">
            <div class="ep-center-image">
                <img
                    alt="Magazine List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'magazine'"
                    src="assets/images/element-page/Left_Magazine.png"
                />
                
                <img
                    alt="Promoted List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'promoted'"
                    src="assets/images/element-page/Left_Promotional.png"
                />

                
                <img
                    alt="General List Layout with Left Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'left' && catalogLayoutConfig.listType == 'general'"
                    src="assets/images/element-page/Left_General.png"
                />
                

                <img
                    alt="Magazine List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'magazine'"
                    src="assets/images/element-page/Top_Magazine.png"
                />
                
                <img
                    alt="Promoted List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'promoted' "
                    src="assets/images/element-page/Top_Promotional.png"
                />

                
                <img
                    alt="General List Layout with Top Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'top' && catalogLayoutConfig.listType == 'general'"
                    src="assets/images/element-page/Top_General.png"
                />

                

                <img
                    alt="Magazine List Layout with Slider Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'magazine'"
                    src="assets/images/element-page/Slider_Magazine.png"
                />

                
                
                <img
                    alt="Promoted List Layout with Slider Filter"
                    *ngIf="
                        catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'promoted'
                    "
                    src="assets/images/element-page/Slider_Promotional.png"
                />

                

                <img
                    alt="General List Layout with Slider Filter"
                    *ngIf="catalogLayoutConfig.filterPlacement == 'slider' && catalogLayoutConfig.listType == 'general'"
                    src="assets/images/element-page/Slider_General.png"
                />

                
            </div>
        </div>

        <!-- backward compatibility ends -->

        <div class="col-sm-3">
            <div class="">
                <span style="font-weight: bold;">Session Display</span>
                <p (cclClick)="catalogLayoutConfig.listType = 'magazine'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'listTypeMagazine'"
                        [value]="'magazine'"
                        [model]="catalogLayoutConfig.listType"
                        >Magazine Style</ccl-radio-button
                    >
                    <span class="sub-detail">Includes Highlighted, Promoted & General Session Display Templates</span>
                    <span class="clearfix"></span>
                    <img *ngIf="catalogLayoutConfig.highlightedStyle == 'list'"
                        alt="Magazine Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'magazine'
                                ? 'assets/images/element-page/Elements_Sessions_Magazine_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_Magazine_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="!catalogLayoutConfig.highlightedStyle && !catalogLayoutConfig.promotedStyle && !catalogLayoutConfig.generalStyle
                    "
                        alt="Magazine Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'magazine'
                                ? 'assets/images/element-page/Elements_Sessions_Magazine_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_Magazine_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="catalogLayoutConfig.highlightedStyle == 'card'"
                        alt="Magazine Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'magazine'
                                ? 'assets/images/element-page/Elements_Sessions_Magazine_Grid_On.png'
                                : 'assets/images/element-page/Elements_Sessions_Magazine_Grid_Off.png'
                        "
                        class="img-height"
                    />
                </p>
                <p  (cclClick)="catalogLayoutConfig.listType = 'promoted'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'listTypePromoted'"
                        [value]="'promoted'"
                        [model]="catalogLayoutConfig.listType"
                        >Promoted Style</ccl-radio-button
                    >
                    <span class="sub-detail">Includes Promoted & General Session Display Templates</span>
                    <span class="clearfix"></span>
                    <img *ngIf="catalogLayoutConfig.promotedStyle == 'list'"
                        alt="Promoted Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'promoted'
                                ? 'assets/images/element-page/Elements_Sessions_Promoted_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_Promoted_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="!catalogLayoutConfig.highlightedStyle && !catalogLayoutConfig.promotedStyle && !catalogLayoutConfig.generalStyle
                    "
                        alt="Promoted Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'promoted'
                                ? 'assets/images/element-page/Elements_Sessions_Promoted_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_Promoted_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="catalogLayoutConfig.promotedStyle == 'card'"
                        alt="Promoted Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'promoted'
                                ? 'assets/images/element-page/Elements_Sessions_Promoted_Grid_On.png'
                                : 'assets/images/element-page/Elements_Sessions_Promoted_Grid_Off.png'
                        "
                        class="img-height"
                    />
                </p>
                <p (cclClick)="catalogLayoutConfig.listType = 'general'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'listTypeGeneral'"
                        [value]="'general'"
                        [model]="catalogLayoutConfig.listType"
                        >General Sessions</ccl-radio-button
                    >
                    <span class="sub-detail">Only the General Session Display Template</span>
                    <span class="clearfix"></span>
                    <img *ngIf="catalogLayoutConfig.generalStyle == 'list'"
                        alt="General Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'general'
                                ? 'assets/images/element-page/Elements_Sessions_General_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_General_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="!catalogLayoutConfig.highlightedStyle && !catalogLayoutConfig.promotedStyle && !catalogLayoutConfig.generalStyle"
                        alt="General Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'general'
                                ? 'assets/images/element-page/Elements_Sessions_General_ON.png'
                                : 'assets/images/element-page/Elements_Sessions_General_OFF.png'
                        "
                        class="img-height"
                    />
                    <img *ngIf="catalogLayoutConfig.generalStyle == 'card'"
                        alt="General Session Display"
                        [src]="
                            catalogLayoutConfig.listType == 'general'
                                ? 'assets/images/element-page/Elements_Sessions_General_Grrid_On.png'
                                : 'assets/images/element-page/Elements_Sessions_General_Grrid_Off.png'
                        "
                        class="img-height"
                    />
                </p>
            </div>
        </div>
    </div>
    <br>
    <br>
    <br>
    <div class="row">
        <div class="col-sm-3">

        </div>

        <div class="col-sm-6">
            <div class="row layout-builder">
                <p *ngIf="catalogLayoutConfig.highlightedStyle &&
                catalogLayoutConfig.promotedStyle &&
                catalogLayoutConfig.generalStyle" (cclClick)="catalogLayoutConfig.highlightedStyle = 'list';
                catalogLayoutConfig.promotedStyle = 'list';
                catalogLayoutConfig.generalStyle = 'list'
                ">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'highlightedStyle-List'"
                        [value]="'list'"
                        [model]="catalogLayoutConfig.highlightedStyle"
                        >List</ccl-radio-button
                    >
                <img
                    alt="Magazine Session Display"
                    [src]="
                        catalogLayoutConfig.highlightedStyle == 'list'
                            ? 'assets/images/element-page/list_option_on.png'
                            : 'assets/images/element-page/list_option_off.png'
                    "
                    class="img-height"
                />
            </p>

            <p *ngIf="!catalogLayoutConfig.highlightedStyle &&
                !catalogLayoutConfig.promotedStyle &&
                !catalogLayoutConfig.generalStyle" (cclClick)="catalogLayoutConfig.highlightedStyle = 'list';
                catalogLayoutConfig.promotedStyle = 'list';
                catalogLayoutConfig.generalStyle = 'list'
                ">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'highlightedStyle-List'"
                        [value]="'list'"
                        [model]="listStyle"
                        >List</ccl-radio-button
                    >
                <img
                    alt="Magazine Session Display"
                    [src]="'assets/images/element-page/list_option_on.png'"
                    class="img-height"
                />
            </p>

            &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;

                <p (cclClick)="catalogLayoutConfig.highlightedStyle = 'card';
                catalogLayoutConfig.promotedStyle = 'card';
                catalogLayoutConfig.generalStyle = 'card'">
                    <ccl-radio-button
                        buttonStyle="c-radiobutton"
                        [name]="'listType'"
                        [id]="'highlightedStyle-Card'"
                        [value]="'card'"
                        [model]="catalogLayoutConfig.highlightedStyle"
                        >Card</ccl-radio-button
                    >
                <img
                    alt="Magazine Session Display"
                    [src]="
                        catalogLayoutConfig.highlightedStyle == 'card'
                            ? 'assets/images/element-page/grid_option_on.png'
                            : 'assets/images/element-page/grid_option_off.png'
                    "
                    class="img-height"
                />
            </p>
            </div>
        </div>

    </div>
</div>
